import API from '../api';

class UserService {
    async edit(id) {
        const res = await API({ method: 'get', url: "/user/edit/" + id });
        return res;
    }

    async updateProfile(data) {
        const res = await API({ method: 'post', url: "/user/update_profile", data: data });
        return res;
    }
    async updatePassword(data) {
        const res = await API({ method: 'post', url: "/user/update_password", data: data });
        return res;
    }
    
}

export default new UserService();